export enum SiteType {
    DISPOSAL_NETWORK = "DN",
    E_PROCUREMENT = "EP",
    HIRE_NETWORK = "HN",
    RELICENSING = "RL",
    SERVICE_NETWORK = "SN",
    TRADE_BUYER = "TB"
}